/**
 * Display currencies an analysis can use. Amounts stay in cents; choosing a
 * currency only changes symbols and formatting.
 *
 * Add a code here, a matching `currency.<CODE>` string in `en.json`, and a
 * label symbol in `CurrencyTextSymbols`. Formatting falls back to the code
 * when the runtime cannot format it.
 */
export const Currencies = [
	'USD',
	'EUR',
	'JPY',
	'GBP',
	'AUD',
	'CAD',
	'CHF',
	'CNH',
	'HKD',
	'NZD',
] as const;

export type Currency = (typeof Currencies)[number];

export const DefaultCurrency: Currency = 'USD';

export function isCurrency(value: unknown): value is Currency {
	return (
		typeof value === 'string' &&
		(Currencies as readonly string[]).includes(value)
	);
}

export function coerceCurrency(value: unknown): Currency {
	return isCurrency(value) ? value : DefaultCurrency;
}
